function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Header_x2F_BG",
  display: "none"
}, React.createElement("rect", {
  x: -182,
  y: -446,
  display: "inline",
  fill: "#F1F1F2",
  width: 520,
  height: 520
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Bounding_Boxes"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_3"
}), React.createElement("path", {
  fill: "none",
  d: "M0,0h24v24H0V0z"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Rounded",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_5",
  display: "inline"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
}), React.createElement("rect", {
  x: 11,
  y: 16,
  width: 2,
  height: 2
}), React.createElement("path", {
  d: "M12.61,6.04c-2.06-0.3-3.88,0.97-4.43,2.79C8,9.41,8.44,10,9.05,10h0.2c0.41,0,0.74-0.29,0.88-0.67 c0.32-0.89,1.27-1.5,2.3-1.28c0.95,0.2,1.65,1.13,1.57,2.1c-0.1,1.34-1.62,1.63-2.45,2.88h0c0,0.01-0.01,0.01-0.01,0.02 c-0.01,0.02-0.02,0.03-0.03,0.05c-0.09,0.15-0.18,0.32-0.25,0.5c-0.01,0.03-0.03,0.05-0.04,0.08c-0.01,0.02-0.01,0.04-0.02,0.07 C11.08,14.09,11,14.5,11,15h1.13h0H13c0-0.42,0.11-0.77,0.28-1.07c0.02-0.03,0.03-0.06,0.05-0.09c0.08-0.14,0.18-0.27,0.28-0.39 c0.01-0.01,0.02-0.03,0.03-0.04c0.1-0.12,0.21-0.23,0.33-0.34c0.96-0.91,2.26-1.65,1.99-3.56C15.72,7.77,14.35,6.3,12.61,6.04z"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Sharp",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_4",
  display: "inline"
}), React.createElement("path", {
  display: "inline",
  d: "M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20 c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5 h2c0-2.25,3-2.5,3-5C16,7.79,14.21,6,12,6z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("g", {
  id: "Outline"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header"
}), React.createElement("path", {
  d: "M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5 C16,7.79,14.21,6,12,6z"
}));

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "Duotone",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy_2",
  display: "inline"
}), React.createElement("g", {
  display: "inline"
}, React.createElement("rect", {
  x: 11,
  y: 16,
  width: 2,
  height: 2
}), React.createElement("path", {
  d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10s10-4.48,10-10C22,6.48,17.52,2,12,2z M12,20c-4.41,0-8-3.59-8-8 c0-4.41,3.59-8,8-8s8,3.59,8,8C20,16.41,16.41,20,12,20z"
}), React.createElement("path", {
  d: "M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5h2c0-2.25,3-2.5,3-5C16,7.79,14.21,6,12,6z"
})));

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  id: "Fill",
  display: "none"
}, React.createElement("g", {
  id: "ui_x5F_spec_x5F_header_copy",
  display: "inline"
}), React.createElement("path", {
  display: "inline",
  d: "M11,18h2v-2h-2V18z M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12,20 c-4.41,0-8-3.59-8-8s3.59-8,8-8s8,3.59,8,8S16.41,20,12,20z M12,6c-2.21,0-4,1.79-4,4h2c0-1.1,0.9-2,2-2s2,0.9,2,2c0,2-3,1.75-3,5 h2c0-2.25,3-2.5,3-5C16,7.79,14.21,6,12,6z"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  id: "nyt_x5F_exporter_x5F_info",
  display: "none"
});

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.b979eee3.svg";
export { ForwardRef as ReactComponent };